/* eslint-disable class-methods-use-this */
import { CancelToken } from 'axios';
import { EntityDto } from 'services/dto';
import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpService';
import { PagedServiceGroupRequest, ServiceGroup } from './dto/serviceGroup';

class ServiceGroupService {
  public async getAll(
    pagedFilterAndSortedRequest: PagedServiceGroupRequest,
    cancelToken?: CancelToken
  ): Promise<PagedResultDto<ServiceGroup>> {
    const result = await http.get('api/services/app/ServiceGroup/GetAll', {
      params: pagedFilterAndSortedRequest,
      cancelToken,
    });
    return result.data.result;
  }

  public async get(entityDto: EntityDto): Promise<ServiceGroup> {
    const result = await http.get('api/services/app/ServiceGroup/GetById', { params: entityDto });
    return result.data.result;
  }

  public async create(serviceGroup: ServiceGroup) {
    const result = await http.post('api/services/app/ServiceGroup/Create', serviceGroup);
    return result.data.result;
  }

  public async update(serviceGroup: ServiceGroup) {
    const result = await http.put('api/services/app/ServiceGroup/Update', serviceGroup);
    return result.data.result;
  }
}

export default new ServiceGroupService();
